var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "200.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M853.333333 213.333333H170.666667C76.8 213.333333 0 290.133333 0 384v426.666667c0 93.866667 76.8 170.666667 170.666667 170.666666h682.666666c93.866667 0 170.666667-76.8 170.666667-170.666666V384c0-93.866667-76.8-170.666667-170.666667-170.666667z m85.333334 597.333334c0 46.933333-38.4 85.333333-85.333334 85.333333H170.666667c-46.933333 0-85.333333-38.4-85.333334-85.333333V384c0-46.933333 38.4-85.333333 85.333334-85.333333h682.666666c46.933333 0 85.333333 38.4 85.333334 85.333333v426.666667z",
    fill: "#3B086B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M640 469.333333H384c-46.933333 0-85.333333 38.4-85.333333 85.333334v128c0 46.933333 38.4 85.333333 85.333333 85.333333h256c46.933333 0 85.333333-38.4 85.333333-85.333333v-128c0-46.933333-38.4-85.333333-85.333333-85.333334z m0 213.333334H384v-128h256v128z",
    fill: "#3B086B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M298.666667 170.666667h426.666666v42.666666h85.333334V170.666667c0-46.933333-38.4-85.333333-85.333334-85.333334H298.666667c-46.933333 0-85.333333 38.4-85.333334 85.333334v42.666666h85.333334V170.666667z",
    fill: "#3B086B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4 597.333333c0-25.6 17.066667-42.666667 42.666667-42.666666h230.4c25.6 0 42.666667 17.066667 42.666666 42.666666s-17.066667 42.666667-42.666666 42.666667H81.066667c-25.6 0-42.666667-17.066667-42.666667-42.666667zM682.666667 597.333333c0-25.6 17.066667-42.666667 42.666666-42.666666h230.4c25.6 0 42.666667 17.066667 42.666667 42.666666s-17.066667 42.666667-42.666667 42.666667H725.333333c-25.6 0-42.666667-17.066667-42.666666-42.666667z",
    fill: "#3B086B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbox);
export default __webpack_public_path__ + "static/media/toolbox.e5e605800888b18f484ed172cb767548.svg";
export { ForwardRef as ReactComponent };